import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Laptop02 = function Laptop02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M21 16V7.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C19.4802 4 18.9201 4 17.8 4H6.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C3 5.5198 3 6.08 3 7.2V16m1.6667 4h14.6666c.62 0 .93 0 1.1843-.0681a2 2 0 0 0 1.4143-1.4143C22 18.2633 22 17.9533 22 17.3333c0-.31 0-.465-.0341-.5921a1 1 0 0 0-.7071-.7071C21.1317 16 20.9767 16 20.6667 16H3.3333c-.31 0-.465 0-.5921.0341a1 1 0 0 0-.7071.7071C2 16.8683 2 17.0233 2 17.3333c0 .62 0 .93.0682 1.1843a2 2 0 0 0 1.4142 1.4143C3.7367 20 4.0467 20 4.6667 20"
    })
  }));
};
export default Laptop02;